var render = function () {
  var _vm$form, _vm$form$main_bookOfT, _vm$form$main_bookOfT2, _vm$form2, _vm$form2$main_bookOf, _vm$form2$main_bookOf2, _vm$form$main_bookOfT3, _vm$form$main_bookOfT4, _vm$form$main_bookOfT5, _vm$form$main_bookOfT6, _vm$form$main_bookOfT7, _vm$form$main_bookOfT8, _vm$form$main_bookOfT9, _vm$form$main_bookOfT10, _vm$form$main_bookOfT11, _vm$form$main_bookOfT12, _vm$form$main_bookOfT13, _vm$form$main_bookOfT14, _vm$form$main_bookOfT15;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "max-width": "720",
      "width": "100%"
    }
  }, [_c('console-title', [_c('v-layout', {
    staticStyle: {
      "gap": "16px"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('span', [_vm._v("이달의 추천 도서")]), _c('v-switch', _vm._b({
    staticClass: "d-inline-block ma-0 pa-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "dense": "",
      "inset": "",
      "hide-details": "",
      "color": "primary"
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.uses,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "uses", $$v);
      },
      expression: "form.main_bookOfTheMonth.uses"
    }
  }, 'v-switch', {
    loading: _vm.loading
  }, false))], 1)], 1), _c('console-body', [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', _vm._b({
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, 'v-card', {
    loading: _vm.loading,
    disable: !_vm.form.main_bookOfTheMonth.uses
  }, false), [_c('v-card-text', [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('autocomplete-shop-product', _vm._b({
    attrs: {
      "label": "도서검색",
      "return-object": "",
      "params": {
        type: 'main',
        searchKey: 'name'
      },
      "clearable": ""
    },
    on: {
      "input": function input() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _id = _ref._id;

        return _vm.form.main_bookOfTheMonth._product = _id || null;
      }
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.product,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "product", $$v);
      },
      expression: "form.main_bookOfTheMonth.product"
    }
  }, 'autocomplete-shop-product', _vm.attrs, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('v-img', {
    staticClass: "v-sheet--outlined",
    attrs: {
      "aspect-ratio": 2 / 3,
      "src": (_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : (_vm$form$main_bookOfT = _vm$form.main_bookOfTheMonth) === null || _vm$form$main_bookOfT === void 0 ? void 0 : (_vm$form$main_bookOfT2 = _vm$form$main_bookOfT.product) === null || _vm$form$main_bookOfT2 === void 0 ? void 0 : _vm$form$main_bookOfT2.thumb,
      "content-class": "d-flex justify-center align-center"
    }
  }, [!((_vm$form2 = _vm.form) !== null && _vm$form2 !== void 0 && (_vm$form2$main_bookOf = _vm$form2.main_bookOfTheMonth) !== null && _vm$form2$main_bookOf !== void 0 && (_vm$form2$main_bookOf2 = _vm$form2$main_bookOf.product) !== null && _vm$form2$main_bookOf2 !== void 0 && _vm$form2$main_bookOf2.thumb) ? [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-image-broken-variant")])] : _vm._e()], 2)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-combobox', _vm._b({
    attrs: {
      "multiple": "",
      "label": "해시태그"
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "tags", $$v);
      },
      expression: "form.main_bookOfTheMonth.tags"
    }
  }, 'v-combobox', _vm.attrs, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "도서제목",
      "placeholder": (_vm$form$main_bookOfT3 = _vm.form.main_bookOfTheMonth) === null || _vm$form$main_bookOfT3 === void 0 ? void 0 : (_vm$form$main_bookOfT4 = _vm$form$main_bookOfT3.product) === null || _vm$form$main_bookOfT4 === void 0 ? void 0 : _vm$form$main_bookOfT4.name,
      "clearable": ""
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "name", $$v);
      },
      expression: "form.main_bookOfTheMonth.name"
    }
  }, 'v-text-field', _vm.attrs, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "작가명",
      "placeholder": (_vm$form$main_bookOfT5 = _vm.form.main_bookOfTheMonth) === null || _vm$form$main_bookOfT5 === void 0 ? void 0 : (_vm$form$main_bookOfT6 = _vm$form$main_bookOfT5.product) === null || _vm$form$main_bookOfT6 === void 0 ? void 0 : _vm$form$main_bookOfT6.writer,
      "clearable": ""
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.writer,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "writer", $$v);
      },
      expression: "form.main_bookOfTheMonth.writer"
    }
  }, 'v-text-field', _vm.attrs, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "출판사",
      "placeholder": (_vm$form$main_bookOfT7 = _vm.form.main_bookOfTheMonth) === null || _vm$form$main_bookOfT7 === void 0 ? void 0 : (_vm$form$main_bookOfT8 = _vm$form$main_bookOfT7.product) === null || _vm$form$main_bookOfT8 === void 0 ? void 0 : _vm$form$main_bookOfT8.publisher,
      "clearable": ""
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.publisher,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "publisher", $$v);
      },
      expression: "form.main_bookOfTheMonth.publisher"
    }
  }, 'v-text-field', _vm.attrs, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "금액",
      "type": "number",
      "placeholder": (_vm$form$main_bookOfT9 = _vm.form.main_bookOfTheMonth) === null || _vm$form$main_bookOfT9 === void 0 ? void 0 : (_vm$form$main_bookOfT10 = _vm$form$main_bookOfT9.product) === null || _vm$form$main_bookOfT10 === void 0 ? void 0 : (_vm$form$main_bookOfT11 = _vm$form$main_bookOfT10.salePrice) === null || _vm$form$main_bookOfT11 === void 0 ? void 0 : (_vm$form$main_bookOfT12 = _vm$form$main_bookOfT11.format) === null || _vm$form$main_bookOfT12 === void 0 ? void 0 : _vm$form$main_bookOfT12.call(_vm$form$main_bookOfT11),
      "clearable": ""
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.salePrice,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "salePrice", $$v);
      },
      expression: "form.main_bookOfTheMonth.salePrice"
    }
  }, 'v-text-field', _vm.attrs, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', _vm._b({
    attrs: {
      "label": "도서소개",
      "rows": "3"
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.text,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "text", $$v);
      },
      expression: "form.main_bookOfTheMonth.text"
    }
  }, 'v-textarea', _vm.attrs, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "링크",
      "placeholder": (_vm$form$main_bookOfT13 = _vm.form.main_bookOfTheMonth) !== null && _vm$form$main_bookOfT13 !== void 0 && _vm$form$main_bookOfT13.product ? "/shop/products/".concat((_vm$form$main_bookOfT14 = _vm.form.main_bookOfTheMonth) === null || _vm$form$main_bookOfT14 === void 0 ? void 0 : (_vm$form$main_bookOfT15 = _vm$form$main_bookOfT14.product) === null || _vm$form$main_bookOfT15 === void 0 ? void 0 : _vm$form$main_bookOfT15._id) : undefined,
      "clearable": ""
    },
    model: {
      value: _vm.form.main_bookOfTheMonth.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form.main_bookOfTheMonth, "name", $$v);
      },
      expression: "form.main_bookOfTheMonth.name"
    }
  }, 'v-text-field', _vm.attrs, false))], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "block": "",
      "color": "error"
    },
    on: {
      "click": _vm.init
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-icon', [_vm._v(" mdi-refresh ")]), _c('span', [_vm._v(" 초기화 ")])], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-icon', [_vm._v(" mdi-content-save ")]), _c('span', [_vm._v(" 저장하기 ")])], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }